export const dateFilters = [
    {
        label: '本月',
        value: 0,
    },
    {
        label: '近二月',
        value: 1,
    },
    {
        label: '近一年',
        value: 2,
    },
    {
        label: '日期區間',
        value: 3,
    },
];
